/*
 * @Author: tangke
 * @Date: 2019-03-26 15:25:55
 * @Last Modified by: others
 * @Last Modified time: 2019-03-26 16:06:27
 * 新增的具体帮助的的弹窗
 */
<template>
  <v-dialog v-model="model"
            width="600">
    <v-card>
      <v-card-title class="title blue-title pa-3 pt-4 ml-2">
        Class ID #{{info.CLID}}
        <div class="header-close" title="close" @click="model = false">
          <v-icon>close</v-icon>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="px-4">
        <div><strong class="blue-title-2">Problem Name: </strong><span class="blue-title">{{assistance.datas.PName}}</span></div>
      </v-card-text>
      <v-card-text class="pt-0 px-4">
        <div><strong class="blue-title-2">Message: </strong>
          <div class="blue-title">{{assistance.datas.state}}</div>
        </div>
      </v-card-text>
      <v-card-text class="pt-0 px-4">
        <div><strong class="blue-title-2">Default Solution: </strong>
          <div class="blue-title" v-html="assistance.datas.DefaultSolution"></div>
        </div>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <v-btn class="text-none red-button dialog-submit"
                    @click="model = false">Close</v-btn>
            </v-flex>
          </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import vmodel from '@/mixins/v-model'
import { createNamespacedHelpers } from 'vuex'
import { GetCSPloblemDetails } from '@/api/classtable.js'
const namespace = 'classDetail'
const { mapGetters } = createNamespacedHelpers(namespace)
export default {
  computed: {
    ...mapGetters(['info'])
  },
  name: 'assistance',
  mixins: [vmodel],
  watch: {
    model (model) {
      if (model) {
        var type = 1// 老师求助
        var that = this.assistance
        GetCSPloblemDetails(this.info.CLID, type).then(res => {
          that.datas.PName = res.PName
          that.datas.state = res.Description
          that.datas.DefaultSolution = res.DefaultSolution
        })
      }
    }
  },
  data: () => ({
    assistance: {
      list: null,
      datas: {
        PName: 'Connection/Equipment issue',
        state: '学生未出现',
        DefaultSolution: '<ol><li>Wait for the student for 2 minutes</li><li>If he/she is still not there, report to CS within 10 minutes. (Otherwise, it may lead to complaints)</li><li data-v-2657ba20="">Keep on contacting the student</li><li data-v-2657ba20="">Mark the student absent after 15m in case of no show.</li></ol>'
      }
    }
  }),
  mounted () {
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
</style>
